export default function Loader() {
    return <span className="loader"></span>;
}
